import { render } from "./PencilIcon.vue?vue&type=template&id=cbef082e&scoped=true"
const script = {}

import "./PencilIcon.vue?vue&type=style&index=0&id=cbef082e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbef082e"]])

export default __exports__